(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-process-docs"] && !Shopify.designMode) return;
  try {
    
  class CustomProcessDocs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-custom-process-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-custom-process-panel]'));
      this.mediaQuery = window.matchMedia('(max-width: 749px)');
      this.mobileAccordion = this.dataset.mobileAccordion === 'true';
      this.panelsContainer = this.querySelector('.custom-process-docs__panels');
      this.handleLayoutChange = this.handleLayoutChange.bind(this);
      this.handleLayoutChange();

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.handleLayoutChange);
      }

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.onTabClick(tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event));
      });
    }

    handleLayoutChange() {
      if (!this.mobileAccordion || !this.panelsContainer) return;

      if (this.mediaQuery.matches) {
        this.tabs.forEach((tab, index) => {
          if (this.panels[index] && this.panels[index].previousElementSibling !== tab) {
            tab.after(this.panels[index]);
          }
        });
      } else {
        this.panels.forEach((panel) => this.panelsContainer.append(panel));
      }
    }

    disconnectedCallback() {
      if (this.mediaQuery && this.mediaQuery.removeEventListener) {
        this.mediaQuery.removeEventListener('change', this.handleLayoutChange);
      }
    }

    onTabClick(tab) {
      const index = Number(tab.dataset.index);
      const isMobileAccordion = this.mobileAccordion && this.mediaQuery.matches;
      const shouldCollapse = isMobileAccordion && tab.getAttribute('aria-expanded') === 'true';

      if (shouldCollapse) {
        this.setActive(index, true);
        return;
      }

      this.setActive(index, false);
    }

    onKeydown(event) {
      if (!['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();

      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;

      this.tabs[nextIndex].focus();
      this.setActive(nextIndex, false);
    }

    setActive(activeIndex, collapse) {
      this.tabs.forEach((tab, index) => {
        const isActive = index === activeIndex && !collapse;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel, index) => {
        const isActive = index === activeIndex && !collapse;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }
  }

  if (!customElements.get('custom-process-docs')) {
    customElements.define('custom-process-docs', CustomProcessDocs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kigurumi-video-gallery"] && !Shopify.designMode) return;
  try {
    
  function kvgActivateScripts(root) {
    root.querySelectorAll('script').forEach(function (oldScript) {
      var newScript = document.createElement('script');

      Array.from(oldScript.attributes).forEach(function (attribute) {
        newScript.setAttribute(attribute.name, attribute.value);
      });

      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }

  function kvgClearDialog(dialog) {
    var content = dialog.querySelector('[data-kvg-dialog-content]');

    if (content) {
      content.replaceChildren();
    }

    dialog.removeAttribute('data-kvg-kind');
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-kvg-open]');

    if (openButton) {
      var gallery = openButton.closest('.kigurumi-video-gallery');
      var dialog = gallery ? gallery.querySelector('[data-kvg-dialog]') : null;
      var content = dialog ? dialog.querySelector('[data-kvg-dialog-content]') : null;

      if (!dialog || !content) return;

      kvgClearDialog(dialog);

      var kind = openButton.dataset.kvgKind;
      dialog.setAttribute('data-kvg-kind', kind);

      if (kind === 'youtube') {
        var videoId = openButton.dataset.kvgVideoId;
        var loop = openButton.dataset.kvgLoop === 'true';
        var iframe = document.createElement('iframe');
        var src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0';

        if (loop) {
          src += '&loop=1&playlist=' + encodeURIComponent(videoId);
        }

        iframe.src = src;
        iframe.title = openButton.getAttribute('aria-label') || 'YouTube';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        content.appendChild(iframe);
      }

      if (kind === 'reddit') {
        var templateId = openButton.dataset.kvgTemplateId;
        var template = templateId ? document.getElementById(templateId) : null;

        if (template) {
          content.appendChild(template.content.cloneNode(true));
          kvgActivateScripts(content);
        }
      }

      if (!dialog.dataset.kvgBound) {
        dialog.addEventListener('close', function () {
          kvgClearDialog(dialog);
        });

        dialog.dataset.kvgBound = 'true';
      }

      dialog.showModal();
      return;
    }

    var closeButton = event.target.closest('[data-kvg-close]');

    if (closeButton) {
      var closeDialog = closeButton.closest('[data-kvg-dialog]');

      if (closeDialog) {
        closeDialog.close();
      }

      return;
    }

    if (event.target.matches('[data-kvg-dialog]')) {
      event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
